





































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { NetworkSecurityInternetGeneralInformationData } from '@/modules/tickets/requirement/network-security-internet/domain/network-security-internet-general-information';
import { LinkManagementData } from '@/modules/tickets/incidents/link-management/domain/link-management-data';
import { NetworkSecurityInternetIncidentData } from '@/modules/tickets/incidents/network-security-internet/domain/network-security-internet-incident-data';

@Component({
    name: 'network-security-internet-ticket-confirmation',
})
export default class NetworkSecurityInternetTicketConfirmation extends Vue {
    @Prop({ required: true })
    generalInformation!: NetworkSecurityInternetIncidentData;

    private isFormValid: boolean = true;

    private isCreatingTicket: boolean = false;

    sendRequirementTicket() {
        this.$emit('sendRequirementTicket');
    }

    previousStep() {
        this.$emit('previousStep');
    }

    reset() {
        this.$emit('reset');
    }
}
